import React, { useRef } from "react";
import { Box, Slide } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const MbSliderAtlas = ({
  openSlide,
  setOpenSlide,
  inputDisabled,
  plusnewchat,
  checked,
  handleNewChatNormal,
  handleNewChatDeep,
  setIsFeedbackOpen,
}) => {
  return (
    <div>
      <Slide
        direction="right"
        in={openSlide}
        mountOnEnter
        unmountOnExit
        className="aip-filter-mb-slide"
      >
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "70%",
            height: "100vh",
            bgcolor: "white",
            zIndex: 10,
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            overflowY: "auto",
            pb: 20,
          }}
        >
          <div className="m-2">
            <div
              onClick={() => setOpenSlide(false)}
              className="mobile-ci-heading-cross"
            >
              <ClearIcon
                onClick={() => {
                  setOpenSlide(false);
                }}
              />{" "}
            </div>
            {inputDisabled ? (
              <p className="Heading-inner-head">
                <img src={plusnewchat} alt="" />
                New Chat{" "}
              </p>
            ) : (
              <p
                className="Heading-inner-head"
                onClick={checked ? handleNewChatNormal : handleNewChatDeep}
              >
                <img src={plusnewchat} alt="" />
                New Chat{" "}
              </p>
            )}

            <button
              className="feedback-fab-mb"
              onClick={() => setIsFeedbackOpen(true)}
            >
              <i className="fa-solid fa-circle-exclamation"></i>
              <span>Feedback</span>
            </button>
          </div>
        </Box>
      </Slide>
    </div>
  );
};

export default MbSliderAtlas;
